import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  tierBarContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: 14,
    alignItems: 'flex-end',
    gap: 1.5,
  },
  tierBar: {
    width: 4,
    borderRadius: 3.5,
    flexShrink: 0,
  },
  tierBarUnknown: {
    paddingLeft: theme.spacing(0.45),
    paddingRight: theme.spacing(0.45),
  },
  /** Filled bar colors from theme palette (success / warning / grey). */
  tierBarActiveHigh: {
    backgroundColor: theme.palette.success.main,
  },
  tierBarActiveMedium: {
    backgroundColor: theme.palette.warning.main,
  },
  tierBarActiveLow: {
    backgroundColor: theme.palette.grey[400],
  },
  tierBarInactive: {
    backgroundColor: theme.palette.grey[300],
  },
}))
